import { NetworkErrorType } from './network-error-type';

/**
 * Backend failures arrive as a FeError thrown by the token interceptor, which
 * carries the server's own message and type (e.g. NOT_ENOUGH_FUNDS). Prefer that
 * message over a hardcoded one so the user is told why the request actually
 * failed; fall back for transport errors, which have no useful message.
 */
export function getApiErrorMessage(err: any, fallback: string): string {
  const message = err?.message || err?.error?.message;
  if (!message || message === 'Network Error') return fallback;
  return message;
}

/**
 * Extract the `NetworkErrorType` from an error.
 *
 * Mobile reference: `NetworkingUtils.getNetworkErrorTypeFromException()`
 *
 * FeError carries `networkErrorType` from the interceptor classification.
 * Falls back to `Unknown` for non-FeError errors.
 */
export function getNetworkErrorType(err: any): NetworkErrorType {
  if (err?.networkErrorType != null) {
    return err.networkErrorType;
  }
  return NetworkErrorType.Unknown;
}

/**
 * Check whether an error represents a network-level failure (no internet,
 * timeout, or maintenance) as opposed to a business-logic error.
 */
export function isNetworkError(err: any): boolean {
  const type = getNetworkErrorType(err);
  return (
    type === NetworkErrorType.NoInternet ||
    type === NetworkErrorType.Timeout ||
    type === NetworkErrorType.Maintenance
  );
}
